import "../../styles/report.css";

export const DataTable = ({ columns, rows, stackMobile = true, totalRow = false, testId }) => {
  return (
    <div className={`report-table-wrap ${stackMobile ? "stack-mobile" : ""}`} data-testid={testId}>
      <table className="report-table">
        <thead>
          <tr>
            {columns.map((c) => (
              <th key={c}>{c}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => {
            const isTotal = totalRow && i === rows.length - 1;
            return (
              <tr key={i} className={isTotal ? "table-total-row" : ""}>
                {row.map((cell, j) => (
                  <td key={j} data-label={columns[j]}>
                    {cell}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
